import { render, staticRenderFns } from "./ObserversInfo.vue?vue&type=template&id=5ce61ee4&"
import script from "./ObserversInfo.vue?vue&type=script&lang=js&"
export * from "./ObserversInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce61ee4')) {
      api.createRecord('5ce61ee4', component.options)
    } else {
      api.reload('5ce61ee4', component.options)
    }
    module.hot.accept("./ObserversInfo.vue?vue&type=template&id=5ce61ee4&", function () {
      api.rerender('5ce61ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/ObserversInfo.vue"
export default component.exports